<template>
  <v-col cols="2">
    <v-select
      v-model="value"
      hide-details
      density="compact"
      :items="sizes"
      variant="outlined"
      :disabled="loading"
      @update:model-value="setFontSize"
    />
  </v-col>
</template>

<script setup lang="ts">
import { ref } from 'vue'
import type { Editor } from '@tiptap/vue-3'

const props = defineProps<{
  editor: Editor
  loading?: boolean
}>()

const sizes = [
  '6px',
  '7px',
  '8px',
  '9px',
  '10px',
  '11px',
  '12px',
  '13px',
  '14px',
  '15px',
  '16px',
  '17px',
  '18px',
  '20px',
  '22px',
  '24px',
  '28px',
  '30px',
  '32px',
  '48px',
]

const value = ref('12px')

const setFontSize = (size: string): void => {
  props.editor.chain().focus().setFontSize(size).run()
}
</script>
